export default __webpack_public_path__ + "static/media/loginBackground.c83cd8cd.jpg";